/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".rms-select-toggle{background:#222;display:-webkit-box;display:flex;border:0;margin:10px 0 10px 10px;padding:0;cursor:pointer;border-radius:2px;height:40px;width:40px;overflow:hidden;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center}.rms-select-toggle .toggle-icon{font-size:large}.rms-select{width:250px;z-index:999;position:relative}[class*=\" icon-ui-\"]:before,[class^=icon-ui-]:before{padding:0}"];
export { styles as styles };
